import {NavigationGuard} from 'vue-router';
import {RouterAliases} from '@/router/routerAliases';
import {registerStoreMainModule, dropSelections} from '@/store/state/helpers';

export const resolveAppRoute: NavigationGuard = async (to, from, next) => {
  // if (to.matched.some((x) => x.name?.toLowerCase().includes('amex'))) {
  const start = process.env.VUE_APP_BASE_URL;
  const path = `${start}/${to.fullPath}`.replace(/\/+/g, '/');
  localStorage.setItem('desiredURL', path);

  if (process.env.VUE_APP_AUTH0_ENABLED) {
    const auth = await import('@/services/auth');
    if (!auth.isLoggedIn()) {
      auth.login();
      return true;
    }
  }

  const path2 = `/${to.fullPath}`.replace(/\/+/g, '/');
  if (path2 === '/' && process.env.VUE_APP_AMEX_AUTH_ENABLED) {
    next({name: RouterAliases.AMEX_LANDING});
    return true;
  }

  if (process.env.VUE_APP_AMEX_AUTH_ENABLED) {
    const auth = await import('@/services/amex-auth');
    if (!auth.isLoggedIn()) {
      auth.amexLogin();
      return true;
    }
  }

  localStorage.removeItem('desiredURL');

  registerStoreMainModule();

  if (path2 === '/') {
    next({name: RouterAliases.DISCOVERY_VIEW});
    return true;
  }

  if (!from.name && to.name === RouterAliases.DISCOVERY_VIEW) {
    dropSelections();
  }

  next();
  return true;
  // }
};
